<template>
  <div>
    <el-select v-model="areaCompany" size="mini" placeholder="大区" style="width: 140px">
      <el-option
        v-for="(item,index)  in areaCompanyMap"
        :key="index"
        :label="item"
        :value="index">
      </el-option>
    </el-select>
    <el-select v-model="provinceBranchCompany" size="mini" placeholder="省区/分公司" style="width: 160px">
      <el-option
        v-for="(item,index) in provinceBranchCompanyMap"
        :key="index"
        :label="item"
        :value="index">
      </el-option>
    </el-select>
    <el-button @click="searchCompen" size="mini" type="primary">搜索</el-button>
    <el-button @click="resetCompen" size="mini"  type="warning" title='清空所有筛选条件'>重置</el-button>
  </div>
</template>

<script>
  export default {
    name: 'deviceSearchBox',
    props: {
      postParams: Object
    },
    data() {
      return {
        sunPostParams: this.postParams,
        areaCompanyMap:[],
        provinceBranchCompanyMap:[],
        areaCompany:'',
        provinceBranchCompany:'',
      }
    },
    mounted(){
      this.initMap()
    },
    methods:{
      initMap(){
        this.$ajax.post("/data/getBigDataIndex_dict",
          {"type":"areaCompanyMap"}
        ).then((res) => {
          this.areaCompanyMap = res.data.data.areaCompanyMap
          this.provinceBranchCompanyMap = res.data.data.provinceBranchCompanyMap
          console.log(this.$route.path)
          if (this.$route.path === '/devicesStart') {
            this.$emit('getGroup', res.data.data.groupMap)
          }
        }).catch((err) => {
          this.$message.error('')
        })
      },
      searchCompen(){
        this.sunPostParams.areaCompany  =this.areaCompany
        this.sunPostParams.provinceBranchCompany  =this.provinceBranchCompany
        this.$emit('getSearchSelect',this.sunPostParams);
      },
      resetCompen(){
        this.areaCompany=''
        this.provinceBranchCompany=''
      }      
    }
  }
</script>
<style>
.el-input.el-input--mini.el-input--suffix {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/devices/components/unDeviceSearchBox.vue